import AppService from "../service/AppService/AppService";

export function getFilters() {
    return AppService.getAxios().get(`/api/filter/all`);
}
